const SidebarData = [
    {
        label: "Menu",
        isMainMenu: true,
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
        issubMenubadge: true,
    },
    {
        label: "Users",
        icon: "ri-group-line",
        subItem: [
            {
                sublabel: "Users", link: "/users"
            }
        ],
    },
    {
        label: "Clients",
        icon: "ri-community-line",
        subItem: [
            {
                sublabel: "Clients", link: "/clients"
            }
        ],
    },
    {
        label: "Companies",
        icon: "mdi mdi-home-group",
        subItem: [
            {
                sublabel: "Companies", link: "/companies"
            }
        ],
    },
    {
        label: "Projects",
        icon: "ri-stack-fill",
        subItem: [
            {
                sublabel: "All", link: "/projects"
            },
            {
                sublabel: "Categories", link: "/project-categories"
            },
            {
                sublabel: "Mapped users", link: "/mapped-users"
            }
        ],
    },

    {
        label: "Valuations",
        icon: "mdi mdi-chart-line",
        subItem: [
            {
                sublabel: "Asset Valuation",
                subMenu: [
                    { title: "Data Collection & Verification", link: "/assets-valuation" },
                    { title: "Data Review", link: "/data-review" },
                    { title: "Deleted Assets", link: "/deleted-assets" },
                    { title: "Data Analysis", link: "/assets-by-category?category=all" },
                    { title: "Combine Institutions", link: "/assets-by-category?category=all&combine=true" },
                    { title: "Reports", link: "/assets-valuation?view=reports" },
                    { title: "Barcodes", link: "/barcodes" },
                    { title: "Barcode Naming Config", link: "/barcode-naming-config" },
                    { title: "Pricing Formulas", link: "/asset-pricing-formulas" },
                    { title: "Pricing", link: "/asset-pricing" },
                    { title: "GAMIS exports", link: "/gamis-exports" },
                    { title: "Asset Imports", link: "/asset-imports" },
                    { title: "Final Reports", link: "/final-reports" },
                    { title: "Report Summary Mapping", link: "/report-summary-management" },
                    { title: "Department Management", link: "/department-management" },
                ],
            },
            {
                sublabel: "Compensation Valuation", link: "/pahs"
            },
            {
                sublabel: "Mortgage Valuation", link: "/mortgages-valuation"
            }
        ],
    },
    {
        label: "Security",
        icon: "ri-lock-line",
        subItem: [
            {
                sublabel: "Roles", link: "/roles"
            },
            {
                sublabel: "Permissions", link: "/permissions"
            }
        ],
    },
    {
        label: "Reports",
        icon: "ri-file-list-3-line",
        subItem: [
            {
                sublabel: "Valuation",
                subMenu: [
                    { title: "Barcode Report", link: "/assets-valuation?view=reports" }
                ]
            },
            {
                sublabel: "Form no.4", link: "/form-3"
            }
        ]
    },
    {
        label: "Payments",
        icon: "ri-bank-card-line",
        subItem: [
            {
                sublabel: "Invoices", link: "/invoices"
            }
        ]
    },
    {
        label: "Settings",
        icon: "ri-settings-3-line",
        subItem: [
            {
                sublabel: "Company profile", link: "/company-profile",
            },
            {
                sublabel: "User profile", link: "/userprofile"
            },
            {
                sublabel: "Crop Categories", link: "/crop-categories"
            },
            {
                sublabel: "Asset Categories", link: "/asset-categories-setup"
            },
            {
                sublabel: "Banks", link: "/banks"
            },
            {
                sublabel: "Crops", link: "/crops-setup"
            },
            {
                sublabel: "Regions", link: "/regions-setup",
            },
            {
                sublabel: "Districts", link: "/districts-setup"
            },
            {
                sublabel: "Councils", link: "/councils-setup"
            },
            {
                sublabel: "Wards", link: "/wards-setup"
            },
            {
                sublabel: "Institutions", link: "/institutions-setup"
            },
            {
                sublabel: "Villages/Mtaa", link: "/villages-setup"
            },
            {
                sublabel: "Hamlets", link: "/hamlets-setup"
            }
        ]
    }

]
export default SidebarData;
